import { FC } from 'react';

import { SearchBarItemProps } from '@components/ui/search/SearchBarInput/SearchBarInputInterface';
import CustomIcon from '@components/utils/CustomIcon';
import { ArrowDownSLine, ArrowUpSLine, Calendar2Line } from '@assets/icons';

import {
  SearchBarItemWrapper,
  SearchBarItemTitleWrapper,
  SearchBarItemLabel,
} from './styled';

const SearchBarItem: FC<SearchBarItemProps> = ({
  isActive,
  InputComponent,
  subTitle,
}) => {
  return (
    <SearchBarItemWrapper>
      <SearchBarItemTitleWrapper>
        <CustomIcon icon={Calendar2Line} fontSize={24} paletteColor='grey500' />
        {InputComponent && (
          <SearchBarItemLabel>{InputComponent}</SearchBarItemLabel>
        )}

        {subTitle && (
          <SearchBarItemLabel>
            <span>{subTitle}</span>
          </SearchBarItemLabel>
        )}
      </SearchBarItemTitleWrapper>
      <CustomIcon
        fontSize={24}
        paletteColor='grey800'
        icon={isActive ? ArrowUpSLine : ArrowDownSLine}
      />
    </SearchBarItemWrapper>
  );
};

export default SearchBarItem;
